<template>
    <v-select
            :label="(label)? label : ''"
            :items="items"
            :value="value"
            item-text="desc"
            item-value="variable"
            chips
            clearable
            @input="actualizaValor($event)"
    >
        <template slot="selection" slot-scope="data">
            <v-chip
                    @input="data.parent.selectItem(data.item)"
                    :selected="data.selected"
                    class="chip--select-multi"
                    :key="JSON.stringify(data.item)"
            >
                <v-avatar v-if="data.item.avatar">
                    <img :src="data.item.avatar "/>
                </v-avatar>
                {{ data.item.desc }}
            </v-chip>
        </template>
        <template slot="item" slot-scope="data">
            <template>
                <v-list-tile-avatar v-if="data.item.avatar">
                    <img :src="data.item.avatar"/>
                </v-list-tile-avatar>
                <v-list-tile-avatar v-else>
                    <img :src="'./img/iso-3.svg'"/>
                </v-list-tile-avatar>
                <v-list-tile-content>
                    <v-list-tile-title v-html="data.item.desc"></v-list-tile-title>
                </v-list-tile-content>
            </template>
        </template>
    </v-select>
</template>
<script>
    export default {
        name: 'empresa-select',
        props: ['items', 'label', 'value'],
        data() {
            return {}
        },
        methods: {
            actualizaValor(valor) {
                this.$emit('input', valor);
                this.$emit('actualiza', valor);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/SelectTerminacion.vue